<template>
  <div>
    
    <div class="pt-1">
      <div class="prompt-preview-container" :class="isDarkMode ? 'dark-container' : 'light-container'">
        <div class="caption grey--text mb-1">System Prompt</div>
        <div class="prompt-preview" :class="isDarkMode ? 'dark-preview' : 'light-preview'" v-if="systemPromptPreview">
          <div v-for="(line, idx) in systemPromptPreview" :key="idx" class="preview-line" :class="isDarkMode ? 'dark-text' : 'light-text'">
            {{ line }}
          </div>
        </div>
        <div v-else class="prompt-preview empty-preview grey--text text--darken-1" :class="isDarkMode ? 'dark-preview' : 'light-preview'">
          No system prompt configured
        </div>
        <v-btn
            small
            flat
            color="secondary"
            class="ma-0 mt-2"
            @click="editingSystemPrompt = true"
        >
          Edit System Prompt
        </v-btn>
      </div>
    </div>

    <div class="pt-1">
      <div class="prompt-preview-container" :class="isDarkMode ? 'dark-container' : 'light-container'">
        <div class="caption grey--text mb-1">Prompt</div>
        <div class="prompt-preview" :class="isDarkMode ? 'dark-preview' : 'light-preview'" v-if="promptPreview">
          <div v-for="(line, idx) in promptPreview" :key="idx" class="preview-line" :class="isDarkMode ? 'dark-text' : 'light-text'">
            {{ line }}
          </div>
        </div>
        <div v-else class="prompt-preview empty-preview grey--text text--darken-1" :class="isDarkMode ? 'dark-preview' : 'light-preview'">
          No prompt configured
        </div>
        <v-btn
            small
            flat
            color="secondary"
            class="ma-0 mt-2"
            @click="editingPrompt = true"
        >
          Edit Prompt
        </v-btn>
      </div>
    </div>
    
    <div class="c-d-flex c-align-center pt-1">
      <div style="width: 50%">
        <v-autocomplete
            dense
            v-model="localLookup.genType"
            :items="[{id: 'html', description: 'HTML'}, {id: 'md', description: 'Markdown'}, {id: 'fieldUpdate', description: 'Field Update'}]"
            label="Generation Type"
            hide-details
            single-line
            color="primary"
            item-text="description"
            item-value="id"
            class="pa-0 ma-0"
        ></v-autocomplete>
      </div>
      <div class="pl-2" style="width: 50%">
        <v-autocomplete
            :loading="loadingModels"
            dense
            v-model="localLookup.model"
            :items="models"
            label="Model"
            hide-details
            single-line
            color="primary"
            item-text="name"
            item-value="id"
            class="pa-0 ma-0"
        ></v-autocomplete>
      </div>
      
      
      
      
    </div>
    
    
    
    
    <div class="c-d-flex c-align-center pt-1">
      <div style="width: 50%">
        <v-text-field
            dense
            v-model="localLookup.buttonTitle"
            label="Button Title"
            hide-details
            single-line
            color="primary"
            class="pa-0 ma-0"
        ></v-text-field>
      </div>
      <div class="pl-2" style="width: 50%">
        <v-text-field
            dense
            v-model.number="localLookup.maxTokens"
            label="Max Tokens"
            hide-details
            single-line
            color="primary"
            class="pa-0 ma-0"
        ></v-text-field>
      </div>
    </div>
    
    <div class="c-d-flex c-align-center pt-1">
<!--      <div style="width: 50%">-->
<!--        <v-text-field-->
<!--            dense-->
<!--            v-model.number="localLookup.maxTokens"-->
<!--            label="Max Tokens"-->
<!--            hide-details-->
<!--            single-line-->
<!--            color="primary"-->
<!--            class="pa-0 ma-0"-->
<!--        ></v-text-field>-->
<!--      </div>-->
      <div class="" style="width: 50%" v-if="localLookup.genType === 'html' || localLookup.genType === 'md'">
        <v-autocomplete
            dense
            v-model="pdfOrientation"
            :items="pdfOrientationOptions"
            label="PDF Orientation"
            hide-details
            single-line
            color="primary"
            item-text="description"
            item-value="id"
            class="pa-0 ma-0"
        ></v-autocomplete>
      </div>
      
      <div class="" style="width: 100%" v-if="localLookup.genType === 'fieldUpdate'">
        <div class="caption grey--text mb-1">Fields Allowed to Update</div>
        <workflow-field-selector-multiple
            v-model="fieldUpdateOptions"
            :steps="steps"
            :fields="fields"
            :field-type-filter="[1, 2, 3, 4, 5, 13]"
        />
      </div>
      
    </div>
    
    <div class="py-2">
      <v-btn small flat color="secondary" class="ma-0" @click="doneRun">Update config</v-btn>
    </div>
    
<!--    <v-btn @click="test">test</v-btn>-->

    <!-- Prompt Editors -->
    <a-i-prompt-editor
      v-if="editingPrompt"
      :shown="editingPrompt"
      v-model="localLookup.prompt"
      title="Edit Prompt"
      @dismiss="editingPrompt = false"
    />

    <a-i-prompt-editor
      v-if="editingSystemPrompt"
      :shown="editingSystemPrompt"
      v-model="localLookup.systemPrompt"
      title="Edit System Prompt"
      @dismiss="editingSystemPrompt = false"
    />

  </div>
</template>

<script>
import InputDlg from "../../../../../../../../components/General/InputDlg";
import {codeBaseMixin} from "../../../../../../../../codeBaseMixin";
import AIPromptEditor from "./AIPromptEditor";
import WorkflowFieldSelectorMultiple from "../../WorkflowFieldSelectorMultiple";

export default {
  mixins: [codeBaseMixin],
  components: {
    appInputDlg: InputDlg,
    AIPromptEditor,
    WorkflowFieldSelectorMultiple,
  },
  props: {
    userInfo: Object,
    value: [String, Object],
    localData: Object,
    steps: Array,
    fieldSets: Array,
    fields: Array,
  },
  data() {
    return {
      showConfigureTemplate: false,
      configuringField: false,
      editingPrompt: false,
      editingSystemPrompt: false,
      localLookup: {
        systemPrompt: null,
        prompt: null,
        model: null,
        maxTokens: null,
        genType: null,
        options: null,
      },
      loadingModels: false,
      models: []
    }
  },
  mounted() {
    this.fillLookup();
    this.fetchModels()
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        //this.fillLookup();
      }
    },
  },
  methods: {
    
    test() {
      console.log({steps: this.steps, fields: this.fields})
    },
    
    async fetchModels() {
      try {
        this.loadingModels = true
        this.models = await this.$newReq('GET', 'task/ai/getModels')
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingModels = false
      }
    },
    
    doneRun() {
      // TODO Save Yourself
      console.log("DONE RUN")
      this.$emit('input', this.localLookup)
      this.configuringField = false;
    },
    
    fillLookup() {
      if (!this.blankString(this.value)) {
        try {
          this.localLookup = typeof this.value == "string" ? JSON.parse(this.value) : JSON.parse(JSON.stringify(this.value || {}));
        } catch (e) {
          try {
            this.localLookup = JSON.parse(this.value.replaceAll('\\"', '"'));
          } catch (e) {
            console.log(e, this.value)
            this.localLookup = {
              evalStr: "",
              force: false
            }
          }
        }
      }
    }
    
  },
  computed: {
    
    isDarkMode() {
      return this.$store.state.darkTheme
    },
    
    systemPrompt: {
      get() {
        return this.localLookup.systemPrompt || false
      },
      set(val) {
        this.$set(this.localLookup, "systemPrompt", val)
      }
    },
    prompt: {
      get() {
        return this.localLookup.prompt || false
      },
      set(val) {
        this.$set(this.localLookup, "prompt", val)
      }
    },
    model: {
      get() {
        return this.localLookup.model || false
      },
      set(val) {
        this.$set(this.localLookup, "model", val)
      }
    },
    maxTokens: {
      get() {
        return this.localLookup.maxTokens || false
      },
      set(val) {
        this.$set(this.localLookup, "maxTokens", val)
      }
    },
    genType: {
      get() {
        return this.localLookup.genType || false
      },
      set(val) {
        this.$set(this.localLookup, "genType", val)
      }
    },
    buttonTitle: {
      get() {
        return this.localLookup.buttonTitle || false
      },
      set(val) {
        this.$set(this.localLookup, "buttonTitle", val)
      }
    },
    options: {
      get() {
        return this.localLookup.options || false
      },
      set(val) {
        this.$set(this.localLookup, "options", val)
      }
    },

    fieldUpdateOptions: {
      get() {
        if (!this.localLookup.options) return []
        try {
          const parsed = JSON.parse(this.localLookup.options)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      },
      set(val) {
        this.$set(this.localLookup, "options", JSON.stringify(val || []))
      }
    },

    promptPreview() {
      if (!this.localLookup.prompt) return null;
      const lines = this.localLookup.prompt.split('\n').filter(line => line.trim());
      return lines.slice(0, 3);
    },

    systemPromptPreview() {
      if (!this.localLookup.systemPrompt) return null;
      const lines = this.localLookup.systemPrompt.split('\n').filter(line => line.trim());
      return lines.slice(0, 3);
    },

    pdfOrientationOptions() {
      return [
        {id: 'portrait', description: 'Portrait'},
        {id: 'landscape', description: 'Landscape'}
      ]
    },

    pdfOrientation: {
      get() {
        if (!this.localLookup.options) return 'portrait'
        try {
          const parsed = typeof this.localLookup.options === 'string'
            ? JSON.parse(this.localLookup.options)
            : this.localLookup.options
          return parsed.pdfOrientation || 'portrait'
        } catch (e) {
          return 'portrait'
        }
      },
      set(val) {
        let currentOptions = {}
        if (this.localLookup.options) {
          try {
            currentOptions = typeof this.localLookup.options === 'string'
              ? JSON.parse(this.localLookup.options)
              : this.localLookup.options
          } catch (e) {
            currentOptions = {}
          }
        }
        currentOptions.pdfOrientation = val
        this.$set(this.localLookup, "options", JSON.stringify(currentOptions))
      }
    },

  }
}
</script>

<style scoped>
.prompt-preview-container {
  padding: 8px;
  border-radius: 4px;
}

.dark-container {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background-color: rgba(0, 0, 0, 0.2);
}

.light-container {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: rgba(0, 0, 0, 0.04);
}

.prompt-preview {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.4;
  padding: 8px;
  border-radius: 4px;
  min-height: 60px;
  max-height: 60px;
  overflow: hidden;
}

.dark-preview {
  background-color: rgba(50, 50, 50, 0.5);
}

.light-preview {
  background-color: rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.preview-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark-text {
  color: rgba(255, 255, 255, 0.87);
}

.light-text {
  color: rgba(0, 0, 0, 0.87);
}

.empty-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: italic;
}
</style>
